<template>
  <div>
    <div v-if="transformer">
      <h4>Details for {{transformer.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{transformer[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="transformer.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "transformer",
  components: {
    BFR
  },
  props: {
    transformer: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["phase", "Phase"],
      ["catNo", "Cat Number"],
      ["kvaRating", "KVA Rating"],
      ["type", "Type"],
      ["primaryVoltage", "Primary Voltage"],
      ["secondaryVoltage", "Secondary Voltage"],
      ["highVoltageAmps", "High Voltage Amps"],
      ["lowVoltageAmps", "Low Voltage Amps"],
      ["iz", "%IZ"],
      ["wt", "WT"],
      ["class", "Class"],
      ["degreeCRise", "Degree C Rise"],
      ["serialNo", "Serial Number"],
      ["styleNo", "Style NO."],
      ["dateCode", "Date Code"],
      ["enclosure", "Enclosure"],
      ["mountingType", "Mounting"],
      ["windingMaterial", "Winding Material"],
      ["depth", "Depth"],
      ["width", "Width"],
      ["height", "Height"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
